import { v4 as uuidv4 } from 'uuid';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';

const confirmFileUpload = (fileId, callback, errorCallback) => {
  return async (dispatch) => {
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      try {
        const response = await axios.put(`/us/upload/file/${fileId}`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            'request-id': uuidv4(),
          },
        });
        console.log(response);
        if (typeof callback === 'function') callback();
        if (response.status === 200) {
          // console.log('im here');
        } else {
          if (typeof errorCallback === 'function') errorCallback();
        }
      } catch (e) {
        console.log(e);
      }
      unsubscribe();
    });
  };
};

export default confirmFileUpload;
